import {getSingleInstanceByName} from "../../core";
import Notification from "../notification/notification"
import {createElementFromHTML} from "@utils/html/html.utils";


const dataLayer = window.dataLayer || [];

export interface Notifications {
  action?: any,
  title: any,
  messages: string[],
  okButton?: string,
  okCallback?: unknown,
  cancelButton?: string,
  cancelCallback?: unknown
}

window.notify = notifyFromAlert;
export function notifyFromAlert(response: any, isjson?: boolean):void {
    if(isjson != undefined && isjson == true) {

        if (response.AnalyticsTrackings && response.AnalyticsTrackings != "") {
          const analytis = (typeof response.AnalyticsTrackings === "string") ? JSON.parse(response.AnalyticsTrackings) : response.AnalyticsTrackings;

          for (let i = 0; i < analytis.length; i++) {
            const catString = analytis[i].CategorieString;
            const actionString = analytis[i].ActionString;
            const libelle = analytis[i].Libelle;

            let idCandidate:any;
            if (analytis[i].IdCandidate) {
              idCandidate = analytis[i].IdCandidate;
            }

            const trackingData = {
              event: "EventGeneric",
              EventCat: catString,
              EventAction: actionString,
              EventLibelle: libelle,
              idCandidat:idCandidate,
              EventName: analytis[i].EventName ?? ""
            };

            dataLayer.push(trackingData);
          }
        }

        const NotificationInstance: Notification = getSingleInstanceByName("Notification");
        if (NotificationInstance) {
            NotificationInstance.notifyFromAlert(response);       
        }

    } else {
        notifyFromHtml(response.action, response.message);
    }
   
}

function notifyFromHtml(action: any, html: any, title?: string) {
    const notification:Notifications = {
        action : action,
        title: "",
        messages: []
    };
    const tmpElement = createElementFromHTML(html) as any
    const children = tmpElement.children
    let index = 1;
    if (title && title != "") {
        notification.title = title;
    } else {
        notification.title = children[index].innerText;
        index++;
    }
    for (let i = index; i < children.length; i++) {
        if (children[i].innerText && children[i].innerText.trim() != "") {
            let message = children[i].innerText;
            // Keep link elements
            children[i].querySelectorAll("a").forEach((link: HTMLElement) => {
              message = message.replace(link.innerText, link.outerHTML);
            });
            notification.messages.push(message);
        }
    }
    notifyUser(notification);
}

export function notifyUser(notification: Notifications): void {
  const NotificationInstance: Notification = getSingleInstanceByName("Notification");
  if (NotificationInstance) {
      NotificationInstance.notify(notification);       
  }
}

export function notifyOnNextPage(notification: any): void {
  const NotificationInstance: Notification = getSingleInstanceByName("Notification");
  if (NotificationInstance) {
      NotificationInstance.notifyOnNextPage(notification);       
  }
}